<template>
  <div>

    <span v-if="data.column.field === 'createdAt'">
      <div class="d-flex justify-content-between text-align-left">
        <span>
          {{ data.row.createdAt }}
        </span>
        <span
          v-if="data.row.statusId === 1"
          class="d-flex"
        >
          <b-button
            v-b-modal.approve-reject-transactions-modal
            variant="link"
            class="p-0"
            @click="modalConfirm(data.row, type = 2)"
          >
            <GjIcon
              name="Check"
              class="text-success"
            />
          </b-button>
          <b-button
            v-b-modal.approve-reject-transactions-modal
            variant="link"
            class="p-0"
            @click="modalConfirm(data.row, type = 3)"
          >
            <GjIcon
              name="Close"
              class="text-danger"
            />
          </b-button>
        </span>
      </div>
    </span>
    <span v-else-if="data.column.field === 'type'">
      {{ getType(data.formattedRow[data.column.field]) }}
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>

</template>
<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const modalConfirm = (data, type) => store.commit('SET_TRANSACTION_TO_APPROVE_REJECT', { data, type })
    const transactionTypes = store.getters.getTypes

    const getType = value => {
      const rowType = transactionTypes.find(type => type.value === value)
      return rowType.text
    }

    return {
      modalConfirm,
      transactionTypes,
      getType,
    }
  },
}
</script>
